var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrameBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 59,
    viewBox: "0 0 105 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 10,
    height: 58,
    rx: 3.5,
    fill: "#E2F9FF",
    stroke: "#4AACC5",
    strokeDasharray: "2 2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 39,
    width: 11,
    height: 20,
    rx: 4,
    fill: "#4AACC5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.0469,
    y: 0.5,
    width: 10,
    height: 58,
    rx: 3.5,
    fill: "#E2F9FF",
    stroke: "#4AACC5",
    strokeDasharray: "2 2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9238,
    y: 18,
    width: 11,
    height: 41,
    rx: 4,
    fill: "#4AACC5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3789,
    y: 0.5,
    width: 10,
    height: 58,
    rx: 3.5,
    fill: "#E2F9FF",
    stroke: "#4AACC5",
    strokeDasharray: "2 2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4707,
    y: 46,
    width: 11,
    height: 13,
    rx: 4,
    fill: "#4AACC5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 57.207,
    y: 0.5,
    width: 10,
    height: 58,
    rx: 3.5,
    fill: "#E2F9FF",
    stroke: "#4AACC5",
    strokeDasharray: "2 2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 56.4258,
    y: 24,
    width: 11,
    height: 35,
    rx: 4,
    fill: "#4AACC5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 75.9531,
    y: 0.5,
    width: 10,
    height: 58,
    rx: 3.5,
    fill: "#E2F9FF",
    stroke: "#4AACC5",
    strokeDasharray: "2 2"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 75.2539,
    y: 33,
    width: 11,
    height: 26,
    rx: 4,
    fill: "#4AACC5"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 94.5,
    y: 0.5,
    width: 10,
    height: 58,
    rx: 3.5,
    fill: "#E2F9FF",
    stroke: "#4AACC5",
    strokeDasharray: "2 2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 24,
    width: 11,
    height: 35,
    rx: 4,
    fill: "#4AACC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameBlue);
export default __webpack_public_path__ + "static/media/Frame_blue.fbdc626634489b32b5630ccc16dde2ac.svg";
export { ForwardRef as ReactComponent };